import React, { useMemo } from "react";
import {
  formatDateIntoDMYToDisplay,
  gethoursAndMins,
  splitDmyDisplayDatePrefixAndYear,
  textTruncate,
} from "Utils/utils";
import CheckBox from "../../../../components/common/checkBox/checkbox";
import { getCaseNoteSupportItemDisplayName } from "Utils/caseNoteSupportItem";

/** Visible chars before "..."; column is ~6% width — balances readability vs ellipsis. */
const SUPPORT_ITEM_NO_HEAD_LEN = 6;

const cell =
  "min-w-0 px-2 py-3 align-top text-sm text-gray-700 sm:px-2.5 sm:py-3.5 sm:text-base";

const NdisClaimNewTableItem = (props) => {
  const { item, checkboxes, handleCheckboxChange, isUserGracePeriodOver } =
    props;

  const dateDeliveredLabel = useMemo(() => {
    if (item.delivered_from && item.delivered_to_date) {
      return `${formatDateIntoDMYToDisplay(
        item.delivered_from
      )} - ${formatDateIntoDMYToDisplay(item.delivered_to_date)}`;
    }
    if (item.delivered_date) {
      return formatDateIntoDMYToDisplay(item.delivered_date);
    }
    return "-";
  }, [item]);

  const createdAtDisplay = formatDateIntoDMYToDisplay(item.created_at);
  const createdAtParts = splitDmyDisplayDatePrefixAndYear(createdAtDisplay);
  const supportItemDisplay = useMemo(
    () => getCaseNoteSupportItemDisplayName(item),
    [item]
  );

  const supportItemNoRaw = String(item.support_item_number ?? "");
  const supportItemNoDisplay = textTruncate(
    supportItemNoRaw,
    SUPPORT_ITEM_NO_HEAD_LEN,
    SUPPORT_ITEM_NO_HEAD_LEN
  );

  return (
    <tr className='even:bg-white odd:bg-gray-50'>
      <td className={`${cell} w-[2%] text-center`}>
        <div className='flex justify-center text-gray-700'>
          <CheckBox
            isDisabled={isUserGracePeriodOver}
            handleChange={handleCheckboxChange}
            checked={checkboxes.indexOf(item.id) !== -1}
          />
        </div>
      </td>
      <td className={`${cell} text-left`}>
        <div
          className='truncate text-gray-700'
          title={String(item.delivered_service_number ?? "")}
        >
          {item.delivered_service_number}
        </div>
      </td>
      <td className={`${cell} text-left`}>
        <div
          className='truncate text-gray-700'
          title={String(supportItemDisplay ?? "")}
        >
          {supportItemDisplay}
        </div>
      </td>
      <td className={`${cell} min-w-0 px-0.5 text-center tabular-nums`}>
        <div
          className='truncate font-medium text-gray-700'
          title={supportItemNoRaw || undefined}
        >
          {supportItemNoDisplay || "—"}
        </div>
      </td>
      <td className={`${cell} text-left`}>
        <div
          className='truncate capitalize text-gray-700'
          title={String(item.created_by ?? "")}
        >
          {textTruncate(item.created_by, 24, 23)}
        </div>
      </td>
      <td className={`${cell} text-left`}>
        <div className='leading-tight' title={createdAtDisplay}>
          {createdAtParts.year ? (
            <>
              <span>{createdAtParts.prefix}</span>
              <wbr />
              <span className='whitespace-nowrap'>{createdAtParts.year}</span>
            </>
          ) : (
            <span className='break-words'>{createdAtDisplay}</span>
          )}
        </div>
      </td>
      <td className={`${cell} text-left`}>
        <div
          className='truncate capitalize text-gray-700'
          title={String(item?.participant ?? "")}
        >
          {item?.participant}
        </div>
      </td>
      <td className={`${cell} whitespace-nowrap text-left`}>
        <div className='truncate text-gray-700' title='NDIA Managed'>
          NDIA Managed
        </div>
      </td>
      <td className={`${cell} text-left`}>
        <div className='truncate text-gray-700' title={dateDeliveredLabel}>
          {dateDeliveredLabel}
        </div>
      </td>
      <td className={`${cell} whitespace-nowrap text-right tabular-nums`}>
        {gethoursAndMins(item?.hours, item?.mints)}
      </td>
      <td className={`${cell} whitespace-nowrap text-right tabular-nums`}>
        {item.km || 0}
      </td>
      <td className={`${cell} whitespace-nowrap text-right tabular-nums`}>
        {`$${
          item.alternative_rate && parseInt(item.alternative_rate, 10) > 0
            ? item.alternative_rate
            : item.original_rate
        }`}
      </td>
      <td className={`${cell} whitespace-nowrap text-right tabular-nums`}>
        {`$${item.total_amount || 0}`}
      </td>
      <td className={`${cell} text-left`}>
        <div
          className='truncate text-gray-700'
          title={
            item.status === "ready_for_extraction"
              ? "Ready For Extraction"
              : ""
          }
        >
          {item.status === "ready_for_extraction" && "Ready For Extraction"}
        </div>
      </td>
      <td className='min-w-0 w-[1%] p-0' aria-hidden='true' />
    </tr>
  );
};

export default NdisClaimNewTableItem;
